import { CopyButton } from '@/components/ui/CopyButton'

interface MessageActionsProps {
  text: string
  isReasoning?: boolean
}

export const MessageActions = ({ text, isReasoning }: MessageActionsProps) => {
  if (isReasoning) return null

  return (
    <div className='mp-agent-message-actions'>
      <CopyButton text={text} />
    </div>
  )
}
